import api from './api'

const loadPartners = (): Promise<Array<IPartner>> => api<Array<IPartner>>({ path: `/partners` })

export interface IPartner extends Record<string, unknown> {
    id: number
    name: string
    description: string
    email: string
    phone: string
    hostName: string
    hasLoadBalancerEditAccess?: boolean
}

export default loadPartners
